"use client";

import React from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StayConnectedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="stay-connected-cta" className="relative py-20 md:py-32 bg-secondary/30 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gradient-to-b from-background/0 via-background/50 to-background/0 pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            Stay Connected
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
            Be the first to know about our upcoming events, exclusive offers, and the latest news.
          </p>
          
          <div className="flex flex-col items-center gap-6">
            <Button size="lg" className="h-auto py-4 px-8 text-xl md:text-2xl rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-green-accent hover:bg-green-accent/90 text-white font-semibold border-none" asChild>
              <Link to="#">
                <MessageSquare className="mr-3 size-6 md:size-7" />
                Join Our Newsletter
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}